import {Button, Space} from "antd";
import {StyledShareServiceWidgetWrapper} from "../../calls/service/share-service-widget/share-service-widget.style";
import {ProfileWidgetSkeleton} from "../../calls/upcoming-calls/profile-widget/profile-widget-skeleton";
import {ShareOfferingWidget} from "../../public-profile/offering/share-offering";
import {
  handleMailLink,
  handleFacebookLink,
  handleProductLink,
  handleTwitterLink,
} from "../../../utils/products";
import {REBRAND_BASE_URL} from "../../../services/config";
import {GetProductApiResponse} from "../../../react-query-hooks/products/types";
import {useGetProfileContext} from "../../../context/profile/profile-context";

const ShareProductWidget = ({
  productData,
  isFetching,
}: {
  isFetching: boolean;
  productData: GetProductApiResponse;
}) => {
  const {state: profileState} = useGetProfileContext();

  const extraParams = {
    facebookLink: handleFacebookLink({
      username: profileState.profileData.username,
    }),
    twitterLink: handleTwitterLink({
      textContent: `I just created a product titled ${productData.product.title} on Coachli!`,
      username: profileState.profileData.username,
    }),
    mailLink: handleMailLink({
      body: `I just created a product titled ${productData.product.title} on Coachli! ${REBRAND_BASE_URL}/${profileState.profileData.username}`,
      subject: "",
    }),
    copyLink: handleProductLink({
      productId: productData.product.id,
      slug: productData.product.slug,
      username: profileState.profileData.username,
      tinyUrl: productData.product.tiny_url,
      windowNav: true,
    }),
  };
  let stripedHtml = productData.product.description.replace(/<[^>]+>/g, "");
  const productDescription = stripedHtml;

  return (
    <StyledShareServiceWidgetWrapper>
      {isFetching ? (
        <ProfileWidgetSkeleton />
      ) : (
        <>
          <h2 className="profile-widget-heading">Share product link</h2>
          <div className="profile-widget-card">
            <Space size={16} direction="vertical" style={{display: "flex"}}>
              <div className="profile-widget-card-header">
                <h3 className="profile-widget-card-user-name">
                  {productData.product.title}
                </h3>
              </div>
              <p className="profile-widget-card-bio">{productDescription}</p>
              {productData.medias.length > 0 ? (
                <>
                  <div>
                    <Button
                      size="small"
                      block
                      htmlType="button"
                      target="_blank"
                      href={handleProductLink({
                        productId: productData.product.id,
                        slug: productData.product.slug,
                        username: profileState.profileData.username,
                        tinyUrl: productData.product.tiny_url,
                        windowNav: true,
                      })}
                    >
                      View product page
                    </Button>
                  </div>
                  <ShareOfferingWidget
                    title="Share product via"
                    extraParams={extraParams}
                  />
                </>
              ) : null}
            </Space>
          </div>
        </>
      )}
    </StyledShareServiceWidgetWrapper>
  );
};

export {ShareProductWidget};
